import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.settings.proxies.title',
    defaultMessage: 'Proxies',
    description: 'title of the settings page',
  },
  buttons: {
    add: {
      id: 'actions.add',
      defaultMessage: 'Add',
      description: 'label of the add button',
    },
  },
  proxy: {
    create: {
      title: {
        id: 'pages.proxy.create.title',
        defaultMessage: 'New proxy',
        description: 'title of the create proxy drawer',
      },
    },
    edit: {
      title: {
        id: 'pages.proxy.edit.title',
        defaultMessage: 'Edit proxy',
        description: 'title of the create proxy drawer',
      },
    },
  },
  actions: {
    delete: {
      id: 'actions.delete',
      defaultMessage: 'Delete',
      description: 'label of the delete button',
    },
  },
  feedback: {
    proxyCreated: {
      id: 'pages.proxy.feedback.proxyCreated',
      defaultMessage: 'Proxy created',
      description: 'success feedback message of the proxy create action',
    },
    proxyNotCreated: {
      id: 'pages.proxy.feedback.proxyNotCreated',
      defaultMessage: 'Proxy could not be created',
      description: 'error feedback message of the proxy create action',
    },
    proxyUpdated: {
      id: 'pages.proxy.feedback.proxyUpdated',
      defaultMessage: 'Proxy updated',
      description: 'success feedback message of the proxy update action',
    },
    proxyNotUpdated: {
      id: 'pages.proxy.feedback.proxyNotUpdated',
      defaultMessage: 'Proxy could not be updated',
      description: 'error feedback message of the proxy update action',
    },
  },
};

export default defineMessages(translations);
